var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7353 2.32422L10.4687 0.292969C10.3517 0.117188 10.1569 0 9.94251 0H2.06981C1.85546 0 1.6411 0.117188 1.52418 0.292969L0.277021 2.32422C-0.385533 3.37891 0.199073 4.82422 1.40726 4.98047C1.50469 5 1.58264 5 1.68008 5C2.26468 5 2.77134 4.74609 3.12211 4.35547C3.47287 4.74609 3.97953 5 4.56413 5C5.12925 5 5.63591 4.74609 5.98668 4.35547C6.33744 4.74609 6.86359 5 7.42871 5C8.01331 5 8.51997 4.74609 8.87073 4.35547C9.2215 4.74609 9.72816 5 10.3128 5C10.4102 5 10.4881 5 10.5856 4.98047C11.7938 4.82422 12.3784 3.37891 11.7353 2.32422ZM10.3128 5.625C10.1179 5.625 9.92303 5.60547 9.74764 5.56641V7.5H2.26468V5.56641C2.06981 5.60547 1.87495 5.625 1.68008 5.625C1.56315 5.625 1.44623 5.625 1.32931 5.60547C1.21239 5.58594 1.11496 5.56641 1.01752 5.54688V9.375C1.01752 9.72656 1.29034 10 1.6411 10H10.3712C10.7025 10 10.9948 9.72656 10.9948 9.375V5.54688C10.8779 5.56641 10.7804 5.60547 10.6635 5.60547C10.5466 5.625 10.4297 5.625 10.3128 5.625Z",
    fill: "#333541"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/storeIcon.f48b7c244092567db67fccc5c134ba16.svg";
export { ForwardRef as ReactComponent };